import React from 'react';
import { cn } from '@/lib/utils';
import { ENTITY_STYLES } from '@/lib/entityStyles';

export default function EntityBadge({ entity, label, compact = false, className }) {
  const style = ENTITY_STYLES[entity] || ENTITY_STYLES.lot;
  const Icon = style.icon;
  return (
    <span className={cn('inline-flex items-center gap-1.5 rounded-md border font-medium', compact ? 'px-2 py-1 text-[11px]' : 'px-2.5 py-1.5 text-xs', style.bg, style.text, style.border, className)}>
      <Icon className="w-3.5 h-3.5" strokeWidth={1.75} />
      {label || style.label}
    </span>
  );
}
